module.exports = __webpack_public_path__ + "img/arrow-left-light.fc27e78d.svg";